// authUtils.js
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "../config/adminUrlConfig";

export const clearAuthAndRedirect = () => {
  localStorage.removeItem("access_token_admin");
  localStorage.removeItem("login_Details");
  Cookies.remove("access_token_admin");
  Cookies.remove("refresh_token");
  window.location.href = "/admin-login";
};

export const attemptTokenRefresh = async () => {
  const refreshToken = Cookies.get("refresh_token");
  if (!refreshToken) throw new Error("No refresh token");

  const res = await axios.post(`${BASE_URL}/api/admin/refreshToken`, {
    refresh_token: refreshToken,
  });

  const { token, refresh_token: newRefresh } = res.data;

  localStorage.setItem("access_token_admin", token);
  Cookies.set("access_token_admin", token, {
    expires: 1 / 24,
    secure: true,
    sameSite: "Lax",
    domain: ".khelouk.in",
  });
  Cookies.set("refresh_token", newRefresh, {
    expires: 7,
    secure: true,
    sameSite: "Lax",
    domain: ".khelouk.in",
  });

  const details = JSON.parse(localStorage.getItem("login_Details") || "{}");
  if (details?.authorisation) {
    details.authorisation.token = token;
    localStorage.setItem("login_Details", JSON.stringify(details));
  }

  return token;
};

export const getLoginDetails = () => {
  try {
    const data = localStorage.getItem("login_Details");
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Error parsing Login Detials", error);
    return null;
  }
};

export const getUserEmail = () => {
  const loginDetails = getLoginDetails();
  return loginDetails?.user?.email || "";
};
